import { render, staticRenderFns } from "./groupCalendar.vue?vue&type=template&id=96428818&scoped=true&"
import script from "./groupCalendar.vue?vue&type=script&lang=js&"
export * from "./groupCalendar.vue?vue&type=script&lang=js&"
import style0 from "./groupCalendar.vue?vue&type=style&index=0&id=96428818&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96428818",
  null
  
)

export default component.exports